import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useBasket } from '../bff-api/baskets/useBasket';
import { getDefaultShipment } from '../bff-api/utils/basket-utils';
import { COUNTRY_CODE } from '../utils/address-utils';
import { QueryKey, useCustomPreferenceOrDefault } from '../utils/api';
import { CustomPreference } from '../utils/api/CustomPreference';
import { isClient } from '../utils/utils';
import { StorageKey } from './model/StorageKey';
import { useLocalStorage } from './useLocalStorage';
import { useUserAddress } from './useUserAddress';
import type { HookProps } from './model/HookProps';

export const useUserZipCode = (props?: HookProps): UseQueryResult<string, unknown> => {
    const { data: basket } = useBasket();
    const eddDefaultZipCode = useCustomPreferenceOrDefault(
        CustomPreference.EDD_DEFAULT_TO_ZIP_CODE,
        '',
    );
    const { data: userAddress } = useUserAddress();
    const localStorageZipCode = useLocalStorage<string>(StorageKey.USER_POSTAL_CODE).data;

    const userAddressZipCode =
        userAddress?.countryCode === COUNTRY_CODE && userAddress.postalCode
            ? userAddress.postalCode
            : null;

    let zipCode: string | undefined;

    if (props?.preferenceForBasketValue && basket) {
        zipCode = getDefaultShipment(basket)?.shippingAddress?.postalCode;
    }

    if (!zipCode) {
        zipCode = String(localStorageZipCode || userAddressZipCode || eddDefaultZipCode);
    }

    return useQuery<unknown, unknown, string>({
        queryFn: () => zipCode,
        queryKey: [QueryKey.USER_ADDRESS_ZIP_CODE, zipCode, !!props?.preferenceForBasketValue],
        enabled: isClient,
    });
};
